export default "__VITE_ASSET__DRO$Iftb__"